import { Component } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import { DrawCollapseService } from '@shared/core/directives/drawCollapse';
import { Observable } from 'rxjs';

@Component({
    selector: 'shared-filters-draw',
    templateUrl: './filters-draw.shared.component.html',
    styleUrls: ['./filters-draw.shared.component.scss']
})
export class FiltersDrawComponent {
    public isVisible: Observable<boolean>;

    public isHomePage$: Observable<boolean>;
    public isLocationsSearchPage$: Observable<boolean>;
    public isLocationDetailsPage$: Observable<boolean>;
    public isCheckoutPage$: Observable<boolean>;
    public isAccountPage$: Observable<boolean>;
    public isLoyaltyHome$: Observable<boolean>;
    public onlineMenuPages$: Observable<APICommon.IOnlineMenuPageResponseModel[]>;
    public canShowOnlineMenu$: Observable<boolean>;
    public isVenueMode$: Observable<boolean>;
    public isAuthorizedMember$: Observable<boolean>;

    constructor(
        public controllers: Controllers,
        public drawCollapseService: DrawCollapseService,
    ) {
        this.isVisible = this.drawCollapseService.drawBreakPoint$;

        this.isHomePage$ = this.controllers.routes.isHomePage$();
        this.isLoyaltyHome$ = this.controllers.routes.isLoyaltyHomePage$();
        this.isLocationsSearchPage$ = this.controllers.routes.isLocationsSearchPage$();
        this.isLocationDetailsPage$ = this.controllers.routes.isLocationDetailsPage$();
        this.isCheckoutPage$ = this.controllers.routes.isCheckoutPage$();
        this.isAccountPage$ = this.controllers.routes.isAccountPage$();
        this.canShowOnlineMenu$ = this.controllers.onlineMenu.canShowOnlineMenuForCurrentLocation$();
        this.onlineMenuPages$ = this.controllers.onlineMenu.onlineMenuPages$();

        this.isVenueMode$ = this.controllers.appSettings.isVenueMode$();
        this.isAuthorizedMember$ = this.controllers.members.isAuthorized$();
    }

    public handleBackToMenuClick($event: Event): void {
        this.controllers.routes.navigateToCartsLocation();
    }

    public handleSignInClick($event: Event): void {
        this.controllers.routes.authAction();
    }

    public handleCreateAccountClick($event: Event): void {
        this.controllers.loyalty.createAccountWithMemberCard();
    }

    public get isMobile(): boolean {
        return window.innerWidth < 768;
    }
}
